<template>
  <div class="node">
    <NodeNav :leftTimes="leftTimes"></NodeNav>
    <div
      class="node-body"
      :class="{ 'node-body-nobind': isShowNoBindAlert }"
      v-loading="isLoadingServices"
    >
      <div class="service" :class="{ 'service-bg2': !isShowNoBindAlert }">
        <!-- <NoBind v-if="isShowNoBindAlert" @bindDeviceClick="bindDeviceClick">
        </NoBind> -->
        <RemoteControl v-if="$store.getters.isRemoteControl"></RemoteControl>

        <Empty v-if="isShowNoBindAlert"></Empty>
        <div v-if="isBindSuccess == 1" class="bind-wrap">
          <div class="bind-content bind-content2">
            <div class="close" @click="isBindSuccess = 0"></div>
            <div class="bind-text">设备绑定成功</div>
            <div class="bind-text2">设备名称：{{ termsTermName }}</div>
            <div class="bind-icon"></div>
          </div>
        </div>
        <div v-else-if="isBindSuccess == 2" class="bind-wrap">
          <div class="bind-content">
            <div class="close" @click="isBindSuccess = 0"></div>
            <div class="bind-text">设备绑定失败</div>
            <div class="bind-text2">错误码：{{ bindErrorCode }}</div>
            <div class="bind-icon bind-icon2"></div>
            <div class="bind-text3">
              <div class="help"></div>
              请加入节点小宝用户群，联系客服获取帮助
            </div>
          </div>
        </div>
        <template v-if="!isShowNoBindAlert">
          <div
            class="no-service"
            :class="{
              'remote-control': $store.getters.isRemoteControl,
            }"
            v-if="
              $store.state.curDev &&
              $store.state.curDev.term &&
              $store.state.curDev.term.status
            "
          >
            <div class="no-icon"></div>
            <div class="no-text">设备离线</div>
            <div class="no-text2">
              <p>&nbsp;</p>
            </div>
          </div>
          <div
            class="no-service"
            :class="{
              'remote-control': $store.getters.isRemoteControl,
            }"
            v-else-if="serviceList.length <= 0"
          >
            <div class="no-icon"></div>
            <div class="no-text">暂无服务</div>
            <div class="no-text2">
              <p>点击下方”发现服务”或”手动添加”</p>
            </div>
          </div>

          <template v-else>
            <!-- <div
              class="about-vip"
              v-if="$store.state.user.vip_left == 0"
              @click="goVipClick"
            >
              <div class="vip-icon"></div>
              <div class="vip-icon2"></div>
              <div class="vip-text">访问次数不限</div>
              <div class="vip-btn">立即开通</div>
            </div> -->
            <!-- <div v-if="$store.state.user.vip_left == 0" class="try-times">
              <div class="try-text">
                剩余体验次数
                <div class="try-count">{{ leftTimes }}</div>
                次
              </div>
            </div> -->
            <div
              class="master-device-service"
              :class="{
                'remote-control': $store.getters.isRemoteControl,
              }"
            >
              <NodeItem
                :mode="nodeMode"
                :index="index"
                :item="item"
                :type="'node'"
                :max_index="10000"
                @nameEditClick="nameEditClick"
                @controlClick="controlClick"
                @removeServiceClick="removeServiceClick"
                @openClick="openClick"
                v-for="(item, index) in serviceList"
                v-bind:key="index"
              ></NodeItem>
            </div>
          </template>
          <div
            class="btns"
            :class="{
              'remote-control': $store.getters.isRemoteControl,
            }"
            v-if="
              !(
                $store.state.curDev &&
                $store.state.curDev.term &&
                $store.state.curDev.term.status
              )
            "
          >
            <template v-if="serviceList.length > 0">
              <div
                class="manager-btn"
                @click="settingClick"
                v-if="nodeMode != 'del'"
              >
                管理
              </div>
              <div class="manager-done-btn" @click="settingDoneClick" v-else>
                完成
              </div>
            </template>
            <div class="btn" @click="addClick" v-if="nodeMode != 'del'">
              手动添加
            </div>
            <div class="btn btn2" @click="findClick" v-if="nodeMode != 'del'">
              发现服务
            </div>
          </div>
        </template>

        <div
          class="how-use"
          @click="goHowClick"
          v-if="!isShowNoBindAlert && !$store.getters.isAppstoreMode && false"
        >
          <div class="how-icon"></div>
          帮助中心
        </div>
      </div>
    </div>
    <ServerTimesLimitAlert
      @onCancelClick="hideServerTimesLimitAlert(false)"
      @onPayClick="onPayClick"
      v-if="isShowServerTimesLimitAlert"
    ></ServerTimesLimitAlert>
    <Control
      :dev="device"
      :item="controlItem"
      :type="controlType"
      :isVipServer="true"
      @closeClick="hideControl"
      v-if="isShowControl && controlItem"
    ></Control>
  </div>
</template>

<script>
import Nav from "@/components/Common/Nav.vue";
import NodeNav from "@/components/Node/NodeNav.vue";
import Empty from "@/components/Node/Empty.vue";
import RemoteControl from "@/components/Node/RemoteControl.vue";
import NoBind from "@/components/remote/NoBind.vue";
import NodeItem from "@/components/Node/NodeItemV4.vue";
import Control from "@/components/remote/Control.vue";
import ServerTimesLimitAlert from "@/components/Node/ServerTimesLimitAlert.vue";

import async from "async";
import { mapActions } from "vuex";
export default {
  components: {
    Nav,
    NodeNav,
    NoBind,
    Control,
    NodeItem,
    Empty,
    ServerTimesLimitAlert,
    RemoteControl,
  },
  data: function () {
    return {
      isShowNoBindAlert: false,
      isBindSuccess: 0, //1绑定成功 2绑定失败
      bindErrorCode: 0,

      list: [], //设备列表
      termsTermName: "",

      isLoadingServices: false,
      isShowServerTimesLimitAlert: false,

      device: {}, // 选择设备信息
      isShowControl: false,
      controlItem: {},
      controlType: "",

      serviceList: [], //服务列表，主设备只能是nas和路由器

      vipDate: "",
      leftTimes: 0,

      nodeMode: "",
    };
  },
  watch: {
    "$store.state.user.vip_left": function () {
      this.renderVipDate();
    },
    "$store.state.user.leftTimes": function () {
      let _that = this;
      _that.leftTimes = _that.$store.state.user.leftTimes;
    },
    "$store.state.isLoadForBind": function () {
      this.getBindget();
    },
    "$store.state.user.uid": function () {
      let _that = this;
      _that.getBindget();
      _that.renderVipDate();
      _that.renderServiceTimes();
    },
    "$store.state.curDev": function () {
      let _that = this;
      _that.settingDoneClick();
      _that.getBindget(true);
      _that.renderServiceTimes();
    },
  },
  methods: {
    ...mapActions([
      "nodeupdate",
      "bindget",
      "nodelist",
      "usrdata",
      "usrdataset",
      "scan",
      "scanlist",
      "speclist",
      "nodelistset",
      "nodelistsetDel",
      "nodelistmanset",
      "nodelistmansetdel",
      "sendUserlog",
      "limitget",
      "bookRegister",
      "goods",
      "getServerTimes",
      "checkBindList",
    ]),
    settingClick: function () {
      this.nodeMode = "del";
    },
    settingDoneClick: function () {
      this.nodeMode = "";
    },
    removeServiceClick: function (data, index) {
      let _that = this;
      _that.sendUserlog(["service_remove", ""]);

      let pid = data.dev.peerid;
      let del = [];
      if (data.dtype == 999 || !data.mac) {
        del = [{ Host: data.ip_str, Port: data.port }];
        _that.nodelistmansetdel([
          pid,
          del,
          function (err, data) {
            if (data && !data.rtn) {
              _that.serviceList.splice(index, 1);
              if (_that.serviceList.length <= 0) {
                _that.settingDoneClick();
              }
              _that.$forceUpdate();
            }
          },
        ]);
      } else {
        // 支持端口删除
        del = [data.mac + "|" + data.port];
        _that.nodelistsetDel([
          pid,
          del,
          function (err, data) {
            if (data && !data.rtn) {
              _that.serviceList.splice(index, 1);
              if (_that.serviceList.length <= 0) {
                _that.settingDoneClick();
              }
              _that.$forceUpdate();
            }
          },
        ]);
      }
    },
    addClick: function () {
      let _that = this;
      _that.$router.push("/home/mapping");
    },

    findClick: function () {
      let _that = this;
      _that.$router.push({
        name: "Search",
        params: { serviceList: _that.serviceList },
      });
    },
    goVipClick: function () {
      let _that = this;
      _that.$router.push("/home/vip");
    },
    goHowClick: function () {
      let _that = this;
      _that.$router.push("/home/answer");
    },

    bindDeviceClick: function (code) {
      let _that = this;

      _that.bookRegister([
        code,
        function (err, data) {
          if (data && !data.rtn && data.register) {
            _that.sendUserlog(["bindDevice_s", code]);
            _that.isBindSuccess = 1;

            _that.getBindget();

            setTimeout(function () {
              _that.isShowNoBindAlert = false;
            }, 1000);
          } else {
            // 绑定失败
            if (data && data.rtn == 10216) {
              // 数量限制
              // _that.showBindLimitAlert(); @todo

              _that.sendUserlog(["bindDevice_f_limit", code + "|10216"]);
            } else {
              _that.sendUserlog(["bindDevice_f", code + "|" + data.rtn]);
            }

            _that.bindErrorCode = data.rtn;
            _that.isBindSuccess = 2;
          }
        },
      ]);
    },
    nameEditClick: function (item) {
      let _that = this;
      if (item.dtype == 999) {
        let addArr = [];
        addArr.push({
          host: item.ip_str,
          port: parseInt(item.port),
          name: item.uname,
          dtype: 999,
        });
        _that.nodelistmanset([
          _that.$store.state.curDev.peerid,
          addArr,
          function () {
            _that.sendUserlog(["serviceName_edit", ""]);
          },
        ]);
      } else {
        _that.nodeupdate([
          _that.$store.state.curDev.peerid,
          item.mac,
          item.uname,
          function (err, data) {
            _that.sendUserlog(["serviceName_edit", ""]);
          },
        ]);
      }
    },

    renderVipDate: function () {
      let _that = this;
      let timestamp = new Date().getTime();
      timestamp += _that.$store.state.user.vip_left * 1000;
      _that.vipDate = new Date(timestamp).Format("yyyy-MM-dd");
    },

    renderServiceTimes: function () {
      let _that = this;
      _that.getServerTimes([
        function (err, data) {
          _that.leftTimes =
            data && data.data && data.data.times ? data.data.times : 0;
        },
      ]);
    },

    controlClick: function (item) {
      let _that = this;
      let isVip = _that.$store.state.user.vip_left > 0;
      if (isVip || _that.leftTimes) {
        _that.controlItem = item;
        _that.controlType = "control";
        _that.device = item.dev;
        _that.showControl();
      } else {
        _that.showServerTimesLimitAlert();
      }
    },
    openClick: function (item) {
      let _that = this;
      _that.controlItem = item;
      _that.device = item.dev;
      _that.controlType = "wakeup";
      _that.showControl();
    },
    showControl: function () {
      this.isShowControl = true;
    },
    hideControl: function () {
      this.isShowControl = false;
    },

    getBindget: function (isNotUpdate) {
      let _that = this;
      let isUpdate = !isNotUpdate;
      _that.serviceList = [];
      //用户是否有绑定设备
      _that.checkBindList([
        isUpdate,
        function (err, terms) {
          if (terms && terms.length > 0) {
            _that.list = terms;
            _that.termsTermName = _that.list[0].term.comment
              ? _that.list[0].term.comment
              : _that.list[0].term.name
              ? _that.list[0].term.name
              : _that.list[0].peerid;
            _that.isShowNoBindAlert = false;
            for (let index = 0; index < _that.list.length; index++) {
              const element = _that.list[index];
              // console.log("_that.list", element);
              element.ip_str = _that.$common.ipConvert(element.ip);
              if (
                element.term &&
                element.term.nic &&
                element.term.nic.length > 0 &&
                !element.term.status
              ) {
                for (let j = 0; j < element.term.nic.length; j++) {
                  const nic = element.term.nic[j];
                  let ip_str = _that.$common.ipConvert(nic.ipv4n);
                  // console.log(element.peerid, ip_str);
                  _that.$common.addTunxx(
                    element.peerid,
                    ip_str,
                    24,
                    _that.sendUserlog
                  );
                }
              }
            }
            // _that.$common.startTunxx(_that.sendUserlog);
            _that.renderServices();
          } else {
            _that.isShowNoBindAlert = true;
          }
        },
      ]);
    },
    renderServices: function () {
      let _that = this;
      let services = [];

      _that.isLoadingServices = true;

      let list = [_that.$store.state.curDev];
      async.eachSeries(
        list,
        function (item, cb) {
          _that.scanServices(item, function (err, data) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];

              element.dev = item;
              // 不过滤
              services.push(element);
              // 过滤本机服务
              // if (item.term && item.term.nic) {
              //   for (let j = 0; j < item.term.nic.length; j++) {
              //     const nic = item.term.nic[j];
              //     if (
              //       element.mac == nic.mac ||
              //       item.peerid.indexOf(element.mac) > -1
              //     ) {
              //       services.push(element);
              //       break;
              //     }
              //   }
              // }
            }
            cb ? cb() : null;
          });
        },

        function () {
          _that.isLoadingServices = false;
          _that.serviceList = services;

          let device_service_off_num = 0;
          let device_service_on_num = 0;

          for (let index = 0; index < services.length; index++) {
            let element = services[index];
            if (element.status == 1) {
              device_service_off_num++;
            } else {
              device_service_on_num++;
            }
          }
          _that.$store.state.user.device_service_off_num =
            device_service_off_num;
          _that.$store.state.user.device_service_on_num = device_service_on_num;
        }
      );
    },
    scanServices: function (dev, cb) {
      let _that = this;
      //扫描服务
      _that.speclist([
        dev.peerid,
        2,
        function (err, data) {
          let searchServiceList = [];
          if (data && !data.rtn && data.jd) {
            for (let i = 0; i < data.jd.length; i++) {
              let svs = data.jd[i].svs;
              // 过滤离线设备
              //   if (data.jd[i].status == 1) {
              //     continue;
              //   }
              if (data.jd[i].dtype) {
                //不显示没有类型的服务
                if (svs) {
                  if (svs.length > 0) {
                    for (let j = 0; j < svs.length; j++) {
                      let item = JSON.parse(JSON.stringify(data.jd[i]));
                      item.ports = [svs[j].port];
                      item.port_name = svs[j].name ? svs[j].name : "";
                      item.rule = svs[j].rule ? svs[j].rule : 0;
                      item.icon = svs[j].icon ? svs[j].icon : "";
                      item.button = svs[j].button ? svs[j].button : "";
                      searchServiceList.push(item);
                    }
                  }
                } else {
                  //没有端口
                  if (data.jd[i].status == 1) {
                    //仅添加离线的能够开机的设备
                    searchServiceList.push(data.jd[i]);
                  }
                }
              }
            }
            _that.rebuildList(searchServiceList, dev);
            cb ? cb(null, searchServiceList) : null;
            return;
          } else {
            cb ? cb(null, searchServiceList) : null;
          }
        },
      ]);
    },
    rebuildList: function (list, dev) {
      let _that = this;

      let nasWebPort =
        dev.term && dev.term.nasWebPort ? dev.term.nasWebPort : "";
      let nasHttpsWebPort =
        dev.term && dev.term.nasHttpsWebPort ? dev.term.nasHttpsWebPort : "";
      let httpRedirectHttps =
        dev.term && dev.term.httpRedirectHttps ? dev.term.httpRedirectHttps : 0;

      let curNasWebPort = nasWebPort ? nasWebPort : nasHttpsWebPort;
      if (httpRedirectHttps && nasHttpsWebPort) {
        curNasWebPort = nasHttpsWebPort;
      }

      _that.$common.rebuildServerItems(list, _that.$store.state.nasExPorts);

      for (let index = list.length - 1; index >= 0; index--) {
        const element = list[index];
        // 自定义服务走兼容模式
        if (element.dtype == 999) {
          element.rule = 1;
        }
        // 联想渠道隐藏nas设备
        if (element.dtype == 1 && _that.$store.state.user.isAllLenvNas) {
          list.splice(index, 1);
        } else if (element.dtype == 1 && element.port == 80) {
          // nas过滤80
          list.splice(index, 1);
        } else if (element.port == 631) {
          // 隐藏打印机631
          list.splice(index, 1);
        }
        //  else if (
        // 	element.dtype == 1 &&
        // 	element.port != 5000 &&
        // 	element.port != 8080 &&
        // 	!_that.$store.state.nasExPorts.includes(element.port)
        // ) {
        // 	// 遍历删除NAS设备非5000或者非8080端口
        // 	if (nasWebPort) {
        // 		// 考虑有nasWebPort的情况
        // 		if (
        // 			element.port == nasWebPort &&
        // 			element.mac == dev.mac
        // 		) {
        // 			element.btn = "NAS管理";
        // 			let pidInfo = _that.$common.getInfoByPid(
        // 				_that.curDev.peerid
        // 			);
        // 			// 铁威马设备管理端口默认rule=1
        // 			if (pidInfo.cid == 108) {
        // 				element.rule = 1;
        // 			}
        // 		} else {
        // 			list.splice(index, 1);
        // 		}
        // 	} else {
        // 		list.splice(index, 1);
        // 	}
        // } else if (
        // 	element.dtype == 3 &&
        // 	element.port != 3389 &&
        // 	!element.status
        // ) {
        // 	// 遍历删除在线电脑设备非3389端口
        // 	list.splice(index, 1);
        // } else if (element.dtype == 2 && element.port != 80) {
        // 	// 遍历删除路由器设备非80端口
        // 	list.splice(index, 1);
        // }
      }
      // nasWebPort端口
      if (nasWebPort) {
        for (let index = 0; index < list.length; index++) {
          // 检查nasWebPort是否已经在服务列表
          const element = list[index];
          if (element.mac == dev.mac && element.port == nasWebPort) {
            list.splice(index, 1);
            break;
          }
        }
      }
      if (nasHttpsWebPort) {
        for (let index = 0; index < list.length; index++) {
          // 检查nasWebPort是否已经在服务列表
          const element = list[index];
          if (element.mac == dev.mac && element.port == nasHttpsWebPort) {
            list.splice(index, 1);
            break;
          }
        }
      }

      if (curNasWebPort) {
        let item = {
          dtype: 1,
          rule: 0,
          ip: dev.ip,
          mac: dev.mac,
          name: dev.term.name ? dev.term.name : "nas",
          port: curNasWebPort,
          ports: [curNasWebPort],
          btn: "NAS管理",
          server_type: nasHttpsWebPort == curNasWebPort ? "https" : "http",
          isNasWebPort: true,
          status: dev.term.status ? dev.term.status : 0,
          isFixed: true,
        };
        let pidInfo = _that.$common.getInfoByPid(dev.peerid);
        // 铁威马设备管理端口默认rule=1
        if (pidInfo.cid == 108) {
          item.rule = 1;
        }
        list.push(item);
      }

      if (dev.term.status) {
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          element.status = dev.term.status;
        }
      }

      // 按ip排序
      list.sort(function (a, b) {
        return a.ip_num - b.ip_num;
      });
    },
    showServerTimesLimitAlert: function () {
      let _that = this;
      _that.isShowServerTimesLimitAlert = true;
    },
    hideServerTimesLimitAlert: function (isShowMore) {
      let _that = this;
      _that.isShowServerTimesLimitAlert = false;
      if (!isShowMore) {
        _that.$emit("closeClick");
      }
    },
    onPayClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/vip" });
    },
  },
  computed: {},
  activated: function () {
    let _that = this;
    //获取设备列表
    if (_that.$store.state.user.uid) {
      _that.getBindget();
      _that.renderVipDate();
      _that.renderServiceTimes();
    } else {
      _that.isShowNoBindAlert = true;
    }
  },
  // mounted: function () {
  // 	let _that = this;
  // 	//获取设备列表
  // 	_that.getBindget();
  // 	_that.renderVipDate();
  // 	_that.renderServiceTimes();
  // },
};
</script>

<style lang="less" scoped>
.home .content .main {
  background: red;
}
.node {
  .node-body.node-body-nobind {
    background-color: transparent;
    height: 500px;
    .service {
      height: 500px;
      border-radius: 4px;
      //   border: 1px solid #dddddd;
      //   background-image: url(../assets/remote/bg.png);
    }
  }
  .node-body {
    // background-color: #ffffff;
    // width: 960px;
    // height: 426px;
    overflow: hidden;
  }
  .service {
    position: relative;
    margin: 0 auto;
    // width: 940px;
    height: 380px;
    padding-top: 8px;
    box-sizing: border-box;
    border-radius: 0px 4px 4px 4px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 4px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    // background-image: url("../assets/home/node/service_list_bg.png");
    // background-image: url(../assets/setting/bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    box-sizing: border-box;
    // border: 1px solid #dddddd;
    border-top: none;
    .bind-wrap {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 4;
      background-color: rgba(0, 0, 0, 0.1);
      width: 100%;
      height: 100%;
      .bind-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 345px;
        height: 396px;
        background-color: #ffffff;
        border-radius: 8px;
        box-sizing: border-box;
        .close {
          position: absolute;
          right: 16px;
          top: 16px;
          width: 24px;
          height: 24px;
          background-image: url("../assets/remote/close2.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
        .bind-text {
          margin-top: 47px;
          font-weight: 600;
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: #143977;
        }
        .bind-text2 {
          margin-top: 8px;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
          color: #000000;
        }
        .bind-icon {
          margin: 0 auto;
          margin-top: 39px;
          width: 198px;
          height: 112px;
          background-image: url("../assets/remote/bindf.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
        .bind-icon2 {
          margin-top: 23px;
          width: 200px;
          height: 200px;
          background-image: url("../assets/remote/bindf2.png");
        }

        .bind-text3 {
          margin-top: 22px;
          color: #666666;
          font-weight: 400;
          font-size: 12px;
          line-height: 24px;
          text-align: center;
          .help {
            display: inline-block;
            margin-right: 8px;
            margin-top: 2px;
            width: 20px;
            height: 20px;
            vertical-align: top;
            background-image: url("../assets/remote/bindHelp.svg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .bind-content2 {
        height: 330px;
      }
    }
    .about-vip {
      position: relative;
      margin: 0 auto;
      width: 904px;
      height: 48px;
      background-image: url("../assets/remote/aboutVip.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      box-shadow: 0px 2px 4px 0px rgba(200, 189, 161, 0.4);
      border-radius: 4px;
      .vip-icon,
      .vip-icon2,
      .vip-text {
        display: inline-block;
        vertical-align: top;
      }
      .vip-icon {
        margin-left: 21px;
        width: 44px;
        height: 44px;
        background-image: url("../assets/remote/aboutVip3.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .vip-icon2 {
        margin-top: 13px;
        width: 55px;
        height: 21px;
        background-image: url("../assets/remote/aboutVip2.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .vip-text {
        margin-left: 4px;
        margin-top: 15px;
        font-size: 12px;
        line-height: 18px;
        color: #5b3d15;
      }
      .vip-btn {
        position: absolute;
        right: 24px;
        top: 10px;
        width: 80px;
        height: 28px;
        background: linear-gradient(270deg, #724007 2%, #9f6f21 94%);
        box-shadow: 0px 2px 3px rgba(97, 59, 14, 0.1);
        border-radius: 20px;
        font-size: 12px;
        color: #eeddc7;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
      }
    }
    .try-times {
      position: relative;
      padding-top: 1px;
      margin: 0 auto;
      margin-top: 12px;
      width: 902px;
      height: 28px;
      box-sizing: border-box;
      text-align: center;

      .line {
        margin-top: 13px;
        width: 100%;
        height: 1px;
        background-color: rgba(153, 153, 153, 0.5);
      }
      .try-text {
        position: relative;
        display: inline-block;
        vertical-align: top;
        line-height: 28px;
        width: 150px;
        color: #666666;
        font-size: 14px;
        .try-count {
          display: inline-block;
          margin-left: 4px;
          margin-right: 4px;
          vertical-align: top;
          font-weight: 600;
          font-size: 20px;
          color: #ee362b;
        }
      }
      .try-text::before {
        position: absolute;
        top: 50%;
        left: -190px;
        transform: translate(-50%, 0);
        content: "";
        width: 372px;
        height: 1px;
        background-color: rgba(153, 153, 153, 0.5);
      }
      .try-text::after {
        position: absolute;
        top: 50%;
        left: 340px;
        transform: translate(-50%, 0);
        content: "";
        width: 372px;
        height: 1px;
        background-color: rgba(153, 153, 153, 0.5);
      }
    }
    ::-webkit-scrollbar {
      width: 0;
    }
    .master-device-service.remote-control {
      width: 610px;
    }
    .master-device-service {
      margin: 0 10px;
      //   min-height: 206px;
      width: 910px;
      height: 100%;
      overflow: auto;
      background-color: #ffffff;
      padding-bottom: 100px;
      box-sizing: border-box;
      -ms-overflow-style: none;
      scrollbar-width: none;

      .master-service-item {
        margin: 6px;
        display: inline-block;
        vertical-align: top;
        width: 292px;
        height: 126px;
        border: 1px solid #d7deec;
        border-radius: 8px;
      }
    }

    .how-use {
      position: absolute;
      padding-top: 1px;
      bottom: 22px;
      right: 22px;
      width: 112px;
      height: 42px;
      border-radius: 120px;
      background-color: #ffffff;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      font-size: 14px;
      line-height: 42px;
      color: #243a5d;
      box-sizing: border-box;
      cursor: pointer;
      z-index: 2;
      .how-icon {
        display: inline-block;
        margin-top: 8px;
        margin-left: 11px;
        margin-right: 5px;
        vertical-align: top;
        width: 24px;
        height: 24px;
        background-image: url("../assets/remote/how.svg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .how-use:hover {
      opacity: 0.9;
    }
  }
  .service-bg2 {
    // background-image: url("../assets/remote/bg4.png");
  }

  .no-service.remote-control {
    width: 620px;
  }

  .no-service {
    margin-top: 90px;
    margin-bottom: 40px;
    text-align: center;
    .no-icon {
      margin: 0 auto;
      width: 90px;
      height: 85px;
      background-image: url("../assets/vip/noService.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .no-text {
      margin-top: 29px;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      color: #1f1f1f;
    }
    .no-text2 {
      margin-top: 5px;
      font-size: 13px;
      line-height: 18px;
      color: #666666;
    }
  }

  .btns.remote-control {
    width: 630px;
  }
  .btns {
    text-align: center;
    padding: 24px 0px;
    position: absolute;
    height: 42px;
    width: 930px;
    bottom: 0px;
    background: rgba(255, 255, 255, 0.96);
    z-index: 2;
    .manager-btn {
      color: #4a4a4a;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px;
      height: 42px;
      line-height: 42px;
      background-image: url(../assets/home/node/setting.svg);
      background-size: 24px 24px;
      background-repeat: no-repeat;
      background-position: left center;
      padding-left: 30px;
      position: absolute;
      left: 30px;
      // top: 0;
    }
    .manager-btn:hover {
      cursor: pointer;
      opacity: 0.9;
    }
    .manager-done-btn {
      color: #4a4a4a;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      height: 42px;
      line-height: 42px;
      background-image: url(../assets/home/node/sure-btn.svg);
      background-size: 16px 16px;
      background-repeat: no-repeat;
      background-position: left 15px center;
      padding-left: 22px;
      position: absolute;
      left: 25px;
      top: 0;
      width: 60px;
      flex-shrink: 0;
      border-radius: 200px;
      background-color: #35c767;
      color: #ffffff;
    }
    .manager-done-btn:hover {
      cursor: pointer;
      opacity: 0.9;
    }
    .btn {
      display: inline-block;
      vertical-align: top;
      width: 156px;
      height: 42px;
      line-height: 42px;
      //   font-weight: 700;
      font-size: 16px;
      color: #1a1f9f;
      background-color: rgba(41, 67, 157, 0.2);
      background: linear-gradient(
        189deg,
        rgba(108, 105, 254, 0.2) 0%,
        rgba(76, 73, 236, 0.2) 35.94%,
        rgba(41, 67, 157, 0.2) 99.24%
      );
      box-shadow: 0px -2px 3px 0px rgba(35, 72, 106, 0.21) inset;
      border-radius: 200px;
      cursor: pointer;
    }
    .btn:hover {
      opacity: 0.9;
    }
    .btn2 {
      margin-left: 24px;
      background-color: #29439d;
      background-image: linear-gradient(
        189deg,
        #6c69fe 0%,
        #4c49ec 35.94%,
        #29439d 99.24%
      );
      color: #ffffff;
    }
  }
}
</style>